<template>
  <div class="welcome">
    <div class="wel_content">
      <h1>欢迎登录灵动岛系统！</h1>
<!--      <img src="../../assets/welcome/wel_text.png" alt="欢迎" />-->
    </div>
  </div>
</template>

<script>
  export default {
    name: "index"
  }
</script>

<style scoped>
  #app .pageMain > div.welcome {
    width: calc(100% - 60px);
    height: calc(100% - 72px);
    /*background-image: url("../../assets/login/background.jpg") !important;*/
    /*background-size: contain;*/
    /*!*background-repeat: no-repeat;*!*/
    /*user-select: none;*/

  }

  .wel_content {
    position: relative;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    display: inline-block;
    /*color: #ffffff;*/
    font-size: 24px;
  }

  img {
    display: block;
  }


</style>